(function () {
  var jsonEl = document.querySelector('[data-product-json]');
  var form = document.querySelector('[data-product-form] form');
  if (!jsonEl || !form) return;

  var product = JSON.parse(jsonEl.textContent);
  var mainImage = document.querySelector('[data-product-main-image]');
  var priceEl = document.querySelector('[data-price-value]');
  var compareEl = document.querySelector('[data-compare-price]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var addBtn = document.querySelector('[data-add-to-cart]');
  var addLabel = document.querySelector('[data-add-label]');
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var stickyAdd = document.querySelector('[data-sticky-add]');
  var stickyAddLabel = document.querySelector('[data-sticky-add-label]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var lightbox = document.querySelector('[data-lightbox]');
  var lightboxImage = document.querySelector('[data-lightbox-image]');

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var value = (Number(cents) / 100).toFixed(2);
    var format = (window.Shopify && window.Shopify.moneyFormat) || '{{amount}}';

    function withCommas(n) {
      return n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function withDots(n) {
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    }
    function withSpaces(n) {
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    }
    function withApostrophe(n) {
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return parts.join('.');
    }

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDots(value).split(',')[0])
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, withSpaces(value).split(',')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDots(value))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withSpaces(value))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostrophe(value))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas(value.split('.')[0]))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas(value));
  }

  function getSelectedOptions() {
    return product.options.map(function (_name, index) {
      var pos = index + 1;
      var checked = form.querySelector('[data-option-position="' + pos + '"]:checked');
      if (checked) return checked.value;
      var select = form.querySelector('select[data-option-position="' + pos + '"]');
      if (select) return select.value;
      return product.variants[0].options[index];
    });
  }

  function findVariant() {
    var selected = getSelectedOptions();
    return product.variants.find(function (variant) {
      return variant.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updateGallery(variant) {
    // Thumbnails carry data-variant-ids rendered server-side.
    // Generic images (no variant ids) are always shown; variant-specific
    // images only for the selected variant.
    var thumbsWrap = document.querySelector('[data-product-thumbs]');
    var activeThumb = null;
    var firstVisible = null;
    var visibleCount = 0;
    var featuredId = variant.featured_image ? String(variant.featured_image.id) : null;

    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      var imageId = String(thumb.getAttribute('data-image-id'));
      var variantIds = (thumb.getAttribute('data-variant-ids') || '')
        .split(',')
        .filter(function (s) { return s !== ''; });
      var show = variantIds.length === 0 || variantIds.indexOf(String(variant.id)) !== -1;
      thumb.hidden = !show;
      thumb.classList.remove('is-active');
      if (show) {
        visibleCount++;
        if (!firstVisible) firstVisible = thumb;
        if (featuredId && imageId === featuredId) activeThumb = thumb;
      }
    });

    if (!activeThumb) activeThumb = firstVisible;
    if (thumbsWrap) thumbsWrap.hidden = visibleCount <= 1;

    if (!mainImage) return;

    if (activeThumb) {
      mainImage.src = activeThumb.getAttribute('data-src');
      activeThumb.classList.add('is-active');
      mainImage.alt = activeThumb.querySelector('img') ? activeThumb.querySelector('img').alt : product.title;
      return;
    }

    if (variant.featured_image) {
      mainImage.src = variant.featured_image.src;
      mainImage.alt = variant.featured_image.alt || product.title;
    }
  }

  function updateVariant() {
    var variant = findVariant();
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(variant.compare_at_price);
      } else {
        compareEl.hidden = true;
        compareEl.textContent = '';
      }
    }

    var label = variant.available ? 'Add to Cart' : 'Sold Out';
    if (addBtn && addLabel) {
      addBtn.disabled = !variant.available;
      addLabel.textContent = label;
    }
    if (stickyAdd && stickyAddLabel) {
      stickyAdd.disabled = !variant.available;
      stickyAddLabel.textContent = label;
    }

    updateGallery(variant);
  }

  form.querySelectorAll('[data-option-input]').forEach(function (input) {
    input.addEventListener('change', updateVariant);
  });

  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (thumb.hidden || !mainImage) return;
      mainImage.src = thumb.getAttribute('data-src');
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Sticky ATC — show after main button leaves viewport (mobile) */
  if (stickyBar && addBtn && 'IntersectionObserver' in window) {
    stickyBar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    io.observe(addBtn);
  }

  if (stickyAdd && addBtn) {
    stickyAdd.addEventListener('click', function () {
      if (!addBtn.disabled) addBtn.click();
    });
  }

  /* Simple lightbox zoom */
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImage || !src) return;
    lightboxImage.src = src;
    lightboxImage.alt = alt || product.title;
    lightbox.hidden = false;
    document.documentElement.classList.add('saha-drawer-open');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.documentElement.classList.remove('saha-drawer-open');
  }

  document.querySelectorAll('[data-gallery-zoom]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = btn.querySelector('img') || mainImage;
      if (img) openLightbox(img.currentSrc || img.src, img.alt);
    });
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  updateVariant();
})();

